import { isBootFeatureEnabled } from "owa-metatags";

/**
 * The GetMailboxSpecificRequestOptionsV2 and additional mailbox properties are enabled by the boot flight
 * @returns True if it is enabled, false otherwise
 */
export function isGetMailboxSpecificRequestOptionsV2Enabled(): boolean {
    return isBootFeatureEnabled("acct-mbxpkg-boot");
}
